<template>
  <div>
    <h2>デバッグ用画面</h2>
    <div>
      <router-link to="/settings">
        戻る
      </router-link>
    </div>
    <div class="mt-3">
      <button @click="onClickDebug">
        <template v-if="isDebug">
          デバッグOFF
        </template>
        <template v-else>
          デバッグON
        </template>
      </button>
    </div>
    <div>
      isDebug: {{ isDebug }}
    </div>

    <div class="mt-3">
      バージョン：{{ version }}
    </div>

    <div>
      アプリ更新日: {{ loadedAt | dateTime }}
    </div>

    <div v-if="env">
      <div>
        NODE_ENV: {{ env.NODE_ENV }}
      </div>
      <div>
        API: {{ env.VUE_APP_API_SERVER_URL }}
      </div>
      <div>
        maintenanceURL: {{ env.VUE_APP_S3_MAINTENANCE_URL }}
      </div>
    </div>

    <div>
      isAndroid: {{ isAndroid }}
    </div>

    <button @click="displayVersion">
      デバッグ情報表示
    </button>

    <button @click="removeSw">
      sw削除
    </button>
    <button @click="updateSw">
      sw更新
    </button>
    <button @click="reload">
      リロード
    </button>
    <div
      v-for="(o, i) in outputs"
      :key="i">
      <p>
        {{ o }}
      </p>
      <br>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { format } from 'date-fns'
export default {
  filters: {
    dateTime(v) {
      if (!v) return ''
      return format(v, 'yyyy/M/d HH:mm')
    }
  },
  data() {
    return {
      outputs: [],
      version: process.env.VUE_APP_COMMIT_VERSION || '(not set)'
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState(['loadedAt', 'isDebug']), 
    canAccessToDebugPage() {
      if (!this.user) return false
      return this.user.email === 'akiradaisuke+sports1@gmail.com' || this.user.email === 'izumi@atma.co.jp'
    },
    isAndroid() {
      const ua = navigator.userAgent.toLowerCase()
      return /android/i.test(ua) && window.innerWidth <= 800
    },
    env() {
      if (!process) return null
      return process.env
    }
  },
  methods: {
    onClickDebug() {
      const isDebug = !this.isDebug
      this.$store.commit('setIsDebug', isDebug)
    },
    displayVersion() {
      const ua = navigator.userAgent.toLowerCase()

      // ブラウザがsafariかどうかを判定
      // 判定条件: useragentの中にsafariは存在し、chromeは存在しない
      // 参考: https://developer.mozilla.org/ja/docs/Web/HTTP/Browser_detection_using_the_user_agent
      const isSafari = ua.indexOf('safari') !== -1 && ua.indexOf('chrome') === -1

      const onTouchStartIsAvailable = typeof document.ontouchstart !== 'undefined' 

      // iOSの判定
      // 参考: https://qiita.com/zprodev/items/7e133e801e88ae966dc5#ipados%E3%81%AF%E3%83%87%E3%83%95%E3%82%A9%E3%83%AB%E3%83%88%E3%81%AEuseragent%E3%81%8Cmacos%E3%81%A8%E5%90%8C%E3%81%98%E3%81%AB%E3%81%AA%E3%82%8B
      const isIOS = isSafari && onTouchStartIsAvailable

      alert(`isIOS: ${isIOS}, `
        + `isSafari:${isSafari}, `
        + `onTouchStartIsAvailable:${onTouchStartIsAvailable}, `
        + `mode:${process.env.NODE_ENV}, `
      )

      alert(window.navigator.serviceWorker)
      alert(window.navigator.serviceWorker.getRegistrations())
      // window.navigator.serviceWorker.getRegistrations()
      //   .then(registrations => {
      //     for (let registration of registrations) {
      //       registration.unregister()
      //     }
      //   })

      this.outputs.push(`isIOS: ${isIOS}, `,)
      this.outputs.push(`isSafari:${isSafari}, `)
      this.outputs.push(`onTouchStartIsAvailable:${onTouchStartIsAvailable}, `)
      this.outputs.push(`mode:${process.env.NODE_ENV}, `)
      this.outputs.push(`mode:${process.env.NODE_ENV}, `)

      this.outputs.push('#######service worker registration')
      window.navigator.serviceWorker.getRegistrations().then(registrations=>{
        this.outputs.push(`length: ${registrations.length}`)
        registrations.forEach(r=>{
          this.outputs.push('##### r info')
          this.outputs.push(r.active)
          this.outputs.push(r.installing)
          this.outputs.push(r.waiting)
          this.outputs.push(r)
        })
      })
    },
    removeSw() {
      if (confirm('serviceWorker消しますか？')) {
        window.navigator.serviceWorker.getRegistrations()
          .then(registrations => {
            this.outputs.push(`length: ${registrations.length}`)
            for (let registration of registrations) {
              registration.unregister().then(result=>{
                this.outputs.push(`result: ${result}`)
              })
            }
          })
      }
    },
    updateSw() {
      if (confirm('serviceWorkerをアップデートしますか？')) {
        window.navigator.serviceWorker.getRegistrations()
          .then(registrations => {
            for (let registration of registrations) {
              registration.update()
            }
          })
      }
    },
    reload() {
      window.location.reload(true)
    }
  }
}
</script>

<style lang="scss" scoped>

.form-group{
  position: relative;
}
.search{  
  &__icon{
    position: absolute;
    left: 4px;
    top: 12px;
  }
  
}
</style>